import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllDeaeratorBudgets = async (page, size, searchString) => {
  const response = await api.get(`/${ENDPOINTS.BUDGET_EXCEL}`, {
    params: {
      page,
      size,
      search: searchString,
    },
  });

  return response.data;
};